import { createFileRoute } from '@tanstack/react-router';

import { ManufacturerImporterPage } from '@/areas/parts/ManufacturerManagement/ManufacturerImporterPage';
import { canCreateManufacturerModule } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/manufacturers/importer')({
    staticData: {
        access: { permissions: ['create:manufacturer'], modulePermissions: canCreateManufacturerModule },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ManufacturerImporterPage />;
}
